import React, { Component } from 'react';
import { Form, Divider } from 'antd';
import { connect } from 'react-redux';

import WidgetSelect from '../WidgetSelect';
import AnnouncementSelect from '../AnnouncementSelect';
import { getCategories } from '../../../../../../actions';

const FormItem = Form.Item;
class CategorySettings extends Component {
  componentDidMount() {
    this.props.getCategories();
  }

  render() {
    const { formItemLayout, category: { categories, announcement, widgets } } = this.props;

    return (
      <Form>
        <FormItem
          {...formItemLayout}
          label="Thông báo"
        >
          <AnnouncementSelect categories={categories} selected={announcement} />
        </FormItem>
        <Divider />
        <FormItem
          {...formItemLayout}
          label="Vị trí 1"
        >
          <WidgetSelect categories={categories} index={1} selected={widgets[1]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 2"
        >
          <WidgetSelect categories={categories} index={2} selected={widgets[2]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 3"
        >
          <WidgetSelect categories={categories} index={3} selected={widgets[3]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 4"
        >
          <WidgetSelect categories={categories} index={4} selected={widgets[4]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 5"
        >
          <WidgetSelect categories={categories} index={5} selected={widgets[5]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 6"
        >
          <WidgetSelect categories={categories} index={6} selected={widgets[6]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 7"
        >
          <WidgetSelect categories={categories} index={7} selected={widgets[7]} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vị trí 8"
        >
          <WidgetSelect categories={categories} index={8} selected={widgets[8]} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label="Vị trí 9"
        >
          <WidgetSelect categories={categories} index={9} selected={widgets[9]} />
        </FormItem>

      </Form>
    );
  }
}

export default connect(state => ({
  category: state.category,
}), {
  getCategories,
})(CategorySettings);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/CategorySettings.js